/**
 * Compliance screening lists (FSD 3.2.1; FIN-T01-R055, V085): the
 * tenant-maintained list a transfer release screens against — parties (name,
 * aliases, BIC) and sanctioned jurisdictions. There is no external sanctions
 * feed; this list is the screen.
 *
 * Gated on `cash.screening.manage`, which every route of the list declares. The
 * wiring packet spreads `TREASURY_SCREENING_ROUTES` beside `TREASURY_ROUTES` and
 * adds the `treasury-screening` nav item.
 */

import type { RouteRecordRaw } from 'vue-router'

import { SCREENING_PERMISSIONS } from '@/modules/treasury/screening/permissions'

export const TREASURY_SCREENING_PATH = '/treasury/screening'

/**
 * Exchange-control rules are the second tab of this screen, not a route of
 * their own: R055 declares sanctions and exchange-control as obligations of one
 * control applied per jurisdiction before a cross-border release, both are
 * enforced by the same release-time screen (an exchange-control breach is a
 * screening hit, cleared the same way), and both routes declare the same
 * permission, `cash.screening.manage`.
 */
export const EXCHANGE_CONTROLS_TAB = 'exchange-controls'

export const SCREENING_PATHS = {
  lists: TREASURY_SCREENING_PATH,
  exchangeControls: `${TREASURY_SCREENING_PATH}?tab=${EXCHANGE_CONTROLS_TAB}`,
} as const

export const TREASURY_SCREENING_ROUTES: RouteRecordRaw[] = [
  {
    path: TREASURY_SCREENING_PATH,
    name: 'treasury-screening',
    component: () => import('@/modules/treasury/screening/ScreeningListsView.vue'),
    meta: {
      titleKey: 'treasury.routeTitles.screeningLists',
      permission: SCREENING_PERMISSIONS.manage,
    },
  },
]
